import * as yup from "yup";

export const defaultLoginSchema = (t: (key: string) => string) => {
    return yup.object({
        userLogonId: yup.string().required(t('main.required.userLogonId')),
        userFirstName: yup.string().when('userLogonId', {
            is: (val: string) => !val?.startsWith('TRA'),
            then: (schema) => schema.required(t('main.required.userFirstName')),
            otherwise: (schema) => schema.notRequired(),
        }),
        userName: yup.string().when('userLogonId', {
            is: (val: string) => !val?.startsWith('TRA'),
            then: (schema) => schema.required(t('main.required.userName')),
            otherwise: (schema) => schema.notRequired(),
        }),
    });
};